import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import logo from '../img/logo/ddd.png';
import aerospace from '../img/envision/dropdown/aerospace.jpg';
import automobility from '../img/envision/dropdown/new/futuristic-mean-transportation-ultra-modern-city_23-2151065406.jpg';
import energy from '../img/envision/dropdown/new/ee.jpg';
import mining from '../img/envision/dropdown/new/minidat.jpg';
import auto from '../img/envision/dropdown/new/aut.png';
import health from '../img/envision/dropdown/new/healthcare.jpg';
import semi from '../img/envision/dropdown/new/semissss.jpg';
import banking from '../img/envision/dropdown/NSJJS.jpg';

import { FaGlobe, FaSearch } from "react-icons/fa"; // Importing FontAwesome icons      

import communication from '../img/envision/dropdown/new/cmd.jpg';
import utilites from '../img/envision/dropdown/new/uu.jpg';
import digital from '../img/envision/aboutdropdown/digital.jpg';
import engineering from '../img/envision/aboutdropdown/aboutengineering.png';
import Manufacturing from '../img/envision/aboutdropdown/manufacturing.png';
import semiconductors from '../img/envision/aboutdropdown/semiconductors.png';
import geospatial from '../img/envision/aboutdropdown/geospatial.png';
import managment from '../img/envision/aboutdropdown/magement.png';
import erp from '../img/envision/aboutdropdown/erp.png';
import about from '../img/envision/aboutdd/aout.png';
import Leadership from '../img/envision/aboutdd/leadership.png';
import values from '../img/envision/aboutdd/vvff.png';
import sustainability from '../img/envision/aboutdd/sustainability.png';
import partnership from '../img/envision/aboutdd/patnership.png';
import qualities from '../img/envision/aboutdd/qualityss.png';
import awards from '../img/envision/aboutdd/aaawww.png';
import socialresponsible from '../img/envision/aboutdd/socialree.png';
import newsresponse from '../img/envision/aboutdd/newsss.png';
import global from '../img/envision/aboutdd/gglns.png';
import poadcoast from '../img/envision/aboutdd/poadcoast.png';
import blog from '../img/envision/dropdown/blog1.png'

import en from '../img/envision/dropdown/new/ee.jpg';
import casestudies from '../img/envision/dropdown/casestudies1.png';
import document from '../img/envision/dropdown/document.png';
import white from '../img/envision/dropdown/whiteone.png';



const Nav = () => {
  const [navbarBackground, setNavbarBackground] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const navigate = useNavigate();
  // State to track the hovered industry
  const [activeImage, setActiveImage] = useState(aerospace); // Using the imported image initially

  const [isOpen, setIsOpen] = useState(false); // State for dropdown visibility  various procedures community and all other formated community things
  const hoverTimeout = useRef(null); // Declare hoverTimeout with useRef
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isWhatWeDoDropdownOpen, setIsWhatWeDoDropdownOpen] = useState(false);
  const [isIndustriesDropdownOpen, setIsIndustriesDropdownOpen] = useState(false);
  const [isWhatWeDoDropdownOpens, setIsWhatWeDoDropdownOpens] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null); // New state
  const [isOpenIndustries, setIsOpenIndustries] = useState(false);
  const [isOpenIndustriess, setIsOpenIndustriess] = useState(false);
  // Handle language change
  const handleLanguageChange = (lang) => {
    setLanguage(lang); // Change the language state
    setIsOpen(false); // Close dropdown after selection
  };
  const [openSubMenu, setOpenSubMenu] = useState(false);

  const handleDocumentClick = () => {
    setOpenSubMenu(!openSubMenu);
  };
  // Image mapping for each industry and service 
  const images = {
    'Industry 1': aerospace,
    'Industry 2': '/img/logo/Picture2.png',
    'Industry 3': '/img/logo/Picture3.png',
    'Service 1 - Industry 1': aerospace,
    'Service 2 - Industry 1': auto,
    'Service 3 - Industry 1': Manufacturing,
    'Service 4 - Industry 1': banking,
    'Service 5 - Industry 1': health,
    'Service 6 - Industry 1': mining,
    'Service 7 - Industry 1': automobility,
    'Service 8 - Industry 1': semi,
    'Service 9 - Industry 1': utilites,
    'Service 10 - Industry 1': digital,
    'Service 11 - Industry 1': engineering,
    'Service 12 - Industry 1': Manufacturing,
    'Service 13 - Industry 1': semiconductors,
    'Service 14 - Industry 1': geospatial,
    'Service 15 - Industry 1': managment,
    'Service 16 - Industry 1': erp,
    'Service 17 - Industry 1': about,
    'Service 18 - Industry 1': Leadership,
    'Service 19 - Industry 1': values,
    'Service 20 - Industry 1': sustainability,
    'Service 21 - Industry 1': partnership,
    'Service 22 - Industry 1': qualities,
    'Service 23 - Industry 1': awards,
    'Service 24 - Industry 1': socialresponsible,
    'Service 25 - Industry 1': newsresponse,
    'Service 26 - Industry 1': global,
    'Service 27 - Industry 1': poadcoast,
    'Service 28 - Industry 1': communication,
    'Service 29 - Industry 1': en,
    'Service 30 - Industry 1': blog,
    'Service 31 - Industry 1': casestudies,
    'Service 32 - Industry 1': document,
    'Service 33 - Industry 1': white,




    // Add more service mappings as needed 
  };

  // Function to handle the hover effect and set active image
  const imageStyles = {
    aerospace: { width: '100px', height: '100px' },
    automobility: { width: '120px', height: '120px' },
    communication: { width: '150px', height: '100px' },
    energy: { width: '200px', height: '100px' },
    mining: { width: '180px', height: '120px' },
    '/img/logo/Picture2.png': { width: '200px', height: '200px' },
    '/img/logo/Picture3.png': { width: '150px', height: '150px' },
    '/img/logo/service2-industry2.jpg': { width: '180px', height: '180px' },
  };
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);

  const handleLanguageClick = (event) => {
    event.preventDefault(); // Prevent default link behavior gathered after responsible of the handleMouseEnter 
    setIsLanguageOpen((prevState) => !prevState); // Toggle language dropdown
    console.log("Dropdown Toggled: ", !isLanguageOpen); // Log to verify toggle
  };



  // Function to handle the hover effect and set active all the reflected units and gathered informations not formated handleMouseEnter = (imageKey) =>{ all the content of the promises of the data and all Envision and the highly recomned things of }
  const handleMouseEnter = (imageKey) => {
    setActiveImage(images[imageKey] || aerospace);
  };

  const [language, setLanguage] = useState(); // State to track selected language
  // Toggle dropdown visibility on button click
  const handleClick = (event) => {
    event.preventDefault(); // Prevent default link behavior
    setIsOpen((prevState) => !prevState); // Toggle the state to open/close the dropdown
  };

  const handleMouseEnters = () => {
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
    }
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
    }
    hoverTimeout.current = setTimeout(() => {
      setIsOpen(false);
    }, 300);
  };


  const pages = [
    { label: "Tool and Fixture Design", path: "/it-services" },
    { label: "Virtual Robotics", path: "/web-mobile-applications" },
    { label: "Digital Facility Solutions", path: "/gaming" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setNavbarBackground(true);
      } else {
        setNavbarBackground(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() === "") {
      setFilteredSuggestions([]);
    } else {
      const lowerQuery = query.toLowerCase();
      setFilteredSuggestions(
        pages.filter((page) => page.label.toLowerCase().includes(lowerQuery))
      );
    }
  };

  const handleSearch = () => {
    if (searchQuery.trim() === "") return;

    const lowerQuery = searchQuery.toLowerCase();
    const matchedPage = pages.find(
      (page) => page.label.toLowerCase() === lowerQuery
    );

    if (matchedPage) {
      navigate(matchedPage.path);
    } else {
      navigate("/not-found");
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion.label);
    navigate(suggestion.path);
    setFilteredSuggestions([]);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };




  return (
    <>
      {/* Navbar Header */}
      <header className="init">
        <div className={`navbar-default-white navbar-fixed-top ${navbarBackground ? 'navbar-scrolled' : ''}`} style={{ background: '#fff', height: '80px' }}>
          <div className="container-fluid">
            <div className="row p-3-vh align-items-center">
              {/* Logo and Text */}
              <Link className="logo centered d-flex align-items-center" to="/">
                <div className="logo d-flex align-items-center">
                  <img alt="logo" src={logo} style={{ maxHeight: '136px', width: '182px', marginBottom: '-16px', marginLeft: '66px', marginTop: '-20px' }} />
                  {/* <h1 style={{ color: "rgb(254 153 0)", textAlign: "center", marginLeft: '50px', marginTop: '23px', marginBottom: '20px', fontSize: '33px' }}>DREBCON</h1> */}

                </div>
              </Link>

              {/* Main Menu */}
              <div className="menu-container mdflbg" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 40px", flexWrap: "wrap" }}>

                {/* Navigation Links */}
                <ul style={{ display: "flex", listStyle: "none", margin: "0", padding: "0", flex: "1", justifyContent: "center" }}>
                  <li className="nav-item mega-dropdown-container"
                    style={{ position: 'relative', color: '#ff9e00' }}
                    onMouseEnter={() => setIsOpenIndustries(true)}
                    onMouseLeave={() => setIsOpenIndustries(false)}
                  >
                    <Link
                      to="/"
                      className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
                      style={{ color: 'rgb(236 115 34)' }}
                    >
                      Industries & Services
                      <i className="fas fa-chevron-down" style={{ marginLeft: '8px', fontSize: '15px' }}></i>
                    </Link>

                    {isOpenIndustries && (
                      <div className="mega-dropdown">
                        <div className="dropdown-content" style={{ display: 'flex', justifyContent: 'space-between' }}>



                          <div
                            className="dropdown-section industries-list col-lg-2 dropdowm-one-data"
                            style={{
                              paddingRight: '10px',
                              display: 'flex',
                              justifyContent: 'center',
                              borderRight: '2px solid #ccc',
                              height: '338px'
                            }}
                          >
                            <ul style={{ listStyle: 'none', padding: 0 }}>

                              <li onMouseEnter={() => handleMouseEnter('Industry 1')}>
                                <h4 className="industries-title">Industries</h4>

                                <ul>

                                  <li onMouseEnter={() => handleMouseEnter('Service 1 - Industry 1')}>
                                    <Link className="industry-link" to="aerospace" onClick={() => setIsOpenIndustries(false)}>
                                      AEROSPACE & DEFENSE
                                    </Link>
                                  </li>
                                  <li onMouseEnter={() => handleMouseEnter('Service 2 - Industry 1')}>
                                    <Link className="industry-link" to="automotivemobility" onClick={() => setIsOpenIndustries(false)}>
                                      AUTOMOTIVE, RAIL & NEXT-GEN MOBILITY
                                    </Link>
                                  </li>
                                  <li onMouseEnter={() => handleMouseEnter('Service 4 - Industry 1')}>
                                    <Link className="industry-link" to="energy" onClick={() => setIsOpenIndustries(false)}>
                                      BFSI
                                    </Link>
                                  </li>

                                  <li onMouseEnter={() => handleMouseEnter('Service 29 - Industry 1')}>
                                    <Link className="industry-link" to="energyPagedata" onClick={() => setIsOpenIndustries(false)}>
                                      ENERGY & INFRASTRCUTURE
                                    </Link> 
                                  </li>
                                  <li onMouseEnter={() => handleMouseEnter('Service 5 - Industry 1')} >
                                    <Link className="industry-link" to="healthcare" onClick={() => setIsOpenIndustries(false)}>
                                      HEALTHCARE & LIFE SCIENCES
                                    </Link>
                                  </li>
                                  <li onMouseEnter={() => handleMouseEnter('Service 3 - Industry 1')}>
                                    <Link className="industry-link" to="manufacturingpage" onClick={() => setIsOpenIndustries(false)}>
                                      MANUFACTURING
                                    </Link>
                                  </li>
                                  <li onMouseEnter={() => handleMouseEnter('Service 28 - Industry 1')}>
                                    <Link className="industry-link" to="communication" onClick={() => setIsOpenIndustries(false)}>
                                      MEDIA & COMMUNICATIONS 
                                    </Link>
                                  </li>


                                </ul>
                              </li>
                            </ul>
                          </div>


                          {/* Right Column: Images */}
                          <div className="dropdown-section industry-image col-lg-10" style={{ textAlign: 'center', paddingLeft: '10px' }}>
                            <img
                              src={activeImage}
                              alt="Industry"
                              style={{
                                width: '83%',
                                height: '85%',
                                objectFit: 'cover',
                                marginTop: '-30px',
                              }}
                              className='industry-img-data'
                            />
                          </div>


                        </div>




                      </div>
                    )}
                  </li>



                  {/* <li className="nav-item mega-dropdowns-container" style={{ position: 'relative' }}>

                  </li> */}

                  <li className="nav-item mega-dropdowns-container" style={{ position: 'relative' }}
                    onMouseEnter={() => setIsOpenIndustriess(true)}
                    onMouseLeave={() => setIsOpenIndustriess(false)}>
                    <Link
                      // to="/carrerspage"
                      className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
                      style={{ color: 'rgb(236 115 34)' }}
                    >
                      Resources
                      <i className="fas fa-chevron-down" style={{ marginLeft: '8px', fontSize: '15px' }}></i>
                    </Link>

                    {isOpenIndustriess && (
                      <div className="mega-dropdowns">
                        <div className="dropdown-content" style={{ display: 'flex', justifyContent: 'space-between' }}>

                          <div
                            className="dropdown-section industries-list col-lg-2"
                            style={{
                              paddingRight: '10px',
                              display: 'flex',
                              justifyContent: 'center',
                              borderRight: '2px solid #ccc',
                              height: '348px'
                            }}
                          >
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              <li>
                                <h4 className="industries-titless">Resources</h4>
                                <ul>
                                  <li onMouseEnter={() => handleMouseEnter('Service 30 - Industry 1')}>
                                    <Link className="industry-link"
                                      // to="digital"
                                      onClick={() => setIsOpenIndustriess(false)}

                                    >BLOGS</Link>
                                  </li>
                                  <li onMouseEnter={() => handleMouseEnter('Service 31 - Industry 1')}>
                                    <Link className="industry-link"
                                      // to="engineeringpage"
                                      onClick={() => setIsOpenIndustriess(false)}
                                    >CASE STUDIES</Link>
                                  </li>
                                  <li onMouseEnter={() => handleMouseEnter('Service 32 - Industry 1')}>
                                    <div style={{ display: 'flex' }}>
                                      <Link className="industry-link"
                                      // to=""
                                      >
                                        DOCUMENTS
                                      </Link>
                                      <button
                                        onClick={handleDocumentClick}
                                        className={`dropdown-toggle-btn ${openSubMenu ? "rotated" : ""}`}
                                      >
                                        ▼
                                      </button>
                                    </div>
                                    {openSubMenu && (
                                      <ul className="sub-dropdown" style={{ width: '400px' }}>
                                        <li>
                                          <Link className="industry-link" to="documentaerospacepage" onClick={() => setIsOpenIndustriess(false)}>AEROSPACE & DEFENSE</Link>
                                        </li>
                                        <li>
                                          <Link className="industry-link" to="documentAutomotivaPage" onClick={() => setIsOpenIndustriess(false)}>AUTOMOTIVE, RAIL & NEXT-GEN MOBILITY</Link>
                                        </li>
                                        <li>
                                          <Link className="industry-link" to="documentBfsipage" onClick={() => setIsOpenIndustriess(false)}>BFSI</Link>
                                        </li>
                                      
                                        <li>
                                          <Link className="industry-link" to="documnetEnergyPage" onClick={() => setIsOpenIndustriess(false)}>  ENERGY & INFRASTRCUTURE</Link>
                                        </li>
                                        <li>
                                          <Link className="industry-link" to="documentHealthcarePage" onClick={() => setIsOpenIndustriess(false)}>HEALTHCARE & LIFE SCIENCES</Link>
                                        </li>
                                        <li>
                                          <Link className="industry-link" to="documnetmanufacturepage" onClick={() => setIsOpenIndustriess(false)}>MANUFACTURING</Link>
                                        </li>
                                        <li>
                                          <Link className="industry-link" to="documentCommunicationPage" onClick={() => setIsOpenIndustriess(false)}>   MEDIA & COMMUNICATIONS </Link>
                                        </li>
                                      </ul>
                                    )}
                                  </li>
                                  <li onMouseEnter={() => handleMouseEnter('Service 33 - Industry 1')}>
                                    <Link className="industry-link"
                                      onClick={() => setIsOpenIndustriess(false)}
                                    //  to="manufacturingpage"
                                    >WHITE PAPERS</Link>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </div>

                          <div className="dropdown-section industry-image col-lg-10" style={{ textAlign: 'center', paddingLeft: '10px' }}>
                            <img
                              src={activeImage}
                              alt="Industry"
                              style={{
                                width: '83%',
                                height: '85%',
                                objectFit: 'cover',
                                marginTop: '-30px',
                              }}
                              className='industry-img-datas'
                            />
                          </div>
                        </div>

                      </div>
                    )}
                  </li>


                  <li
                    className="nav-item mega-dropdownss-container"
                    style={{ position: 'relative' }}
                    onMouseEnter={() => setIsOpen(true)}  // Open on hover
                    onMouseLeave={() => setIsOpen(false)}  // Close on hover out
                  >
                    <Link
                      to="/"
                      className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
                      style={{ color: 'rgb(236 115 34)' }}
                    >
                      About
                      <i className="fas fa-chevron-down" style={{ marginLeft: '8px', fontSize: '15px' }}></i>
                    </Link>

                    {/* Mega Dropdown */}
                    <div
                      className={`mega-dropdownss ${isOpen ? 'open' : ''}`}
                      style={{ position: 'absolute', top: '108%', left: '0%', transform: 'translateX(-50%)' }}
                    >
                      <div className="dropdown-content" style={{ display: 'flex', justifyContent: 'space-between' }}>

                        <div
                          className="dropdown-section industries-list col-lg-2"
                          style={{
                            paddingRight: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                            borderRight: '2px solid #ccc',
                            height: '340px'
                          }}
                        >
                          <ul style={{ listStyle: 'none', padding: 0 }}>

                            <li onMouseEnter={() => handleMouseEnter('Industry 1')}>
                              <h4 className="industries-titles">  About Us</h4>
                              <ul>
                                <li onMouseEnter={() => handleMouseEnter('Service 17 - Industry 1')}>
                                  <Link className="industry-link"
                                    to="aboutleadership"
                                    onClick={() => setIsOpen(false)}
                                  >
                                  ABOUT US
                                  </Link>
                                </li>
                                <li onMouseEnter={() => handleMouseEnter('Service 18 - Industry 1')}>
                                  <Link className="industry-link"
                                    to="aboutleadership"
                                    onClick={() => setIsOpen(false)}
                                  >
                                    LEADERSHIP
                                  </Link>
                                </li>
                                <li onMouseEnter={() => handleMouseEnter('Service 19 - Industry 1')}>
                                  <Link className="industry-link"
                                    // to="firstvalue"
                                    onClick={() => setIsOpen(false)}
                                  >
                                  VALUE FIRST
                                  </Link>
                                </li>
                                <li onMouseEnter={() => handleMouseEnter('Service 4 - Industry 1')} >
                                  <Link className="industry-link"
                                    //  to="aboutdiversity"
                                    onClick={() => setIsOpen(false)}
                                  >
                                     DIVERSITY & INCLUSION
                                  </Link>
                                </li>





                              </ul>
                            </li>
                          </ul>
                        </div>


                        <div
                          className="dropdown-section industry-image col-lg-10"
                          style={{ textAlign: 'center', paddingLeft: '10px' }}
                        >
                          <img
                            src={activeImage}
                            alt="Industry"
                            style={{
                              width: '83%',
                              height: '85%',
                              objectFit: 'cover',
                              marginTop: '-30px',
                            }}
                            className='industry-img-datass'
                          />
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/"
                      className={`nav-link ${location.pathname === '/sign-up' ? 'active-link' : ''}`}
                      style={{ fontWeight: 'bold', fontSize: '20px', color: 'rgb(236 115 34)' }}
                    >
                      <i className="fas fa-search"></i>
                    </Link>

                    {/* Dropdown Menu with Search Bar */}
                    <div className="dropdown-menu">
                      <div className="dropdown-item">
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control"
                          style={{ width: '200px' }}
                        />
                      </div>

                    </div>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/"
                      className={`nav-link ${location.pathname === '/sign-up' ? 'active-link' : ''}`}
                      style={{ fontWeight: 'bold', fontSize: '20px', color: 'rgb(236 115 34)' }}
                    >
                      <FaGlobe style={{ marginRight: "5px" }} />
                    </Link>

                    {/* Dropdown Menu with Search Bar */}
                    <div className="dropdown-menu">
                      <div className="dropdown-item">
                        <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                          <li>
                            <button
                              className="dropdown-item"
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: "8px 16px",
                              }}
                              onClick={() => handleLanguageChange("EN")}
                            >
                              English
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: "8px 16px",
                              }}
                              onClick={() => handleLanguageChange("FR")}
                            >
                              French
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: "8px 16px",
                              }}
                              onClick={() => handleLanguageChange("ES")}
                            >
                              Spanish
                            </button>
                          </li>
                        </ul>
                      </div>

                    </div>
                  </li>


                  {/* Language Dropdown */}





                  <li>
                    <Link
                      to="talktous"
                      className={`nav-link ${location.pathname === '/sign-up' ? 'active-link' : ''}`}
                      style={{
                        fontWeight: 'bold',
                        fontSize: '20px',
                        // border: '2px solid #000',  
                        padding: '5px 10px',  // Add padding to make space around the text all the related coding formated things also we have to
                        borderRadius: '50px',  // Optional: adds rounded corners
                        textDecoration: 'none',  // Optional: removes underline from the link various formated things and All the data not recevied itn 
                        background: '#000',
                        color: 'rgb(236 115 34)'
                      }}
                    >
                      Talk to Us
                    </Link>
                  </li>

                </ul>





                {/* Sidebar Toggle Button for Large Screens */}

              </div>
              <div className="menu-right centered d-none d-md-block">
                <ul className="iconright">
                  <li>
                    <div onClick={toggleSidebar} className="toggle-button">
                      <span className="ti-menu"></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>


      {/* <div> */}
      {/* Sidebar for Large Screens */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-content">
          <ul>
            <li>
              <Link
                to="/"
                onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
                className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
              >
                Home
              </Link>
            </li>
            <li className="dropdown">
              <Link
                to="/"
                onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
                className='nav-link'
              >
                Industries & Services
              </Link>
              <span
                onClick={(e) => {
                  e.preventDefault(); // Prevents navigation
                  setIsWhatWeDoDropdownOpen(!isWhatWeDoDropdownOpen);
                }}
                style={{ cursor: 'pointer', marginTop: '10px', color: '#fff' }} // Style for better UX
              >
                {/* Replace with an icon component or <i> element if needed */}
                ▼
              </span>
              {isWhatWeDoDropdownOpen && (
                <ul className="dropdown-menu">
                  <li onMouseEnter={() => handleMouseEnter('Service 1 - Industry 1')}>
                    <Link className="industry-link" to="aerospace" onClick={() => setIsSidebarOpen(false)}>
                    AEROSPACE & DEFENSE
                    </Link>
                  </li>
                  <li onMouseEnter={() => handleMouseEnter('Service 2 - Industry 1')}>
                    <Link className="industry-link" to="automotivemobility" onClick={() => setIsSidebarOpen(false)}>
                      AUTOMOTIVE, RAIL & NEXT-GEN MOBILITY
                    </Link>
                  </li>
                  <li onMouseEnter={() => handleMouseEnter('Service 4 - Industry 1')}>
                    <Link className="industry-link" to="energy" onClick={() => setIsSidebarOpen(false)}>
                      BFSI
                    </Link>
                  </li>
                 
                  <li onMouseEnter={() => handleMouseEnter('Service 29 - Industry 1')}>
                    <Link className="industry-link" to="energyPagedata" onClick={() => setIsSidebarOpen(false)}>
                      ENERGY
                    </Link>
                  </li>
                  <li onMouseEnter={() => handleMouseEnter('Service 5 - Industry 1')} >
                    <Link className="industry-link" to="healthcare" onClick={() => setIsSidebarOpen(false)}>
                      HEALTHCARE & LIFE SCIENCES
                    </Link>
                  </li>
                  <li onMouseEnter={() => handleMouseEnter('Service 3 - Industry 1')}>
                    <Link className="industry-link" to="manufacturingpage" onClick={() => setIsSidebarOpen(false)}>
                      MANUFACTURING
                    </Link>
                  </li>
                  <li onMouseEnter={() => handleMouseEnter('Service 28 - Industry 1')}>
                    <Link className="industry-link" to="communication" onClick={() => setIsSidebarOpen(false)}>
                    MEDIA & COMMUNICATIONS INDUSTRY
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className="dropdown">
              <Link
                to="/#"
                onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
                className='nav-link'
              >
                Resources
              </Link>
              <span
                onClick={(e) => {
                  e.preventDefault(); // Prevents navigation
                  setIsIndustriesDropdownOpen(!isIndustriesDropdownOpen);
                }}
                style={{ cursor: 'pointer', marginTop: '10px', color: '#fff' }} // Style for better UX
              >
                {/* Replace with an icon component or <i> element if needed */}
                ▼
              </span>
              {isIndustriesDropdownOpen && (
                <ul className="dropdown-menu">
                  <li>
                    {/* <h4 className="industries-titless">Resources</h4> */}
                    <ul>
                      <li onMouseEnter={() => handleMouseEnter('Service 30 - Industry 1')}>
                        <Link className="industry-link"
                          // to="digital"
                          onClick={() => setIsSidebarOpen(false)}
                        >BLOGS</Link>
                      </li>
                      <li onMouseEnter={() => handleMouseEnter('Service 31 - Industry 1')}>
                        <Link className="industry-link"
                          // to="engineeringpage"
                          onClick={() => setIsSidebarOpen(false)}
                        >CASE STUDIES</Link>
                      </li>
                      <li onMouseEnter={() => handleMouseEnter('Service 32 - Industry 1')}>
                        <div style={{ display: 'flex' }}>
                          <Link className="industry-link"
                            onClick={() => setIsSidebarOpen(false)}
                          // to=""
                          >
                            DOCUMENTS
                          </Link>
                          <button
                            onClick={handleDocumentClick}
                            className={`dropdown-toggle-btn ${openSubMenu ? "rotated" : ""}`}
                          >
                            ▼
                          </button>
                        </div>
                        {openSubMenu && (
                          <ul className="sub-dropdown" style={{ background: '#313840', marginTop: '40px',width:'300px' }}>
                            <li>
                              <Link className="industry-link" to="documentaerospacepage" onClick={() => setIsSidebarOpen(false)}>AEROSPACE & DEFENSE</Link>
                            </li>
                            <li>
                              <Link className="industry-link" to="documentAutomotivaPage" onClick={() => setIsSidebarOpen(false)}>AUTOMOTIVE, RAIL & NEXT-GEN MOBILITY</Link>
                            </li>
                            <li>
                              <Link className="industry-link" to="documentBfsipage" onClick={() => setIsSidebarOpen(false)}>BFSI</Link>
                            </li>
                           
                            <li>
                              <Link className="industry-link" to="documnetEnergyPage" onClick={() => setIsSidebarOpen(false)}>ENERGY</Link>
                            </li>
                            <li>
                              <Link className="industry-link" to="documentHealthcarePage" onClick={() => setIsSidebarOpen(false)}>HEALTHCARE & LIFE SCIENCES</Link>
                            </li>
                            <li>
                              <Link className="industry-link" to="documnetmanufacturepage" onClick={() => setIsSidebarOpen(false)}>MANUFACTURING</Link>
                            </li>
                            <li>
                              <Link className="industry-link" to="documentCommunicationPage" onClick={() => setIsSidebarOpen(false)}>MEDIA & COMMUNICATIONS </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                      <li onMouseEnter={() => handleMouseEnter('Service 33 - Industry 1')}>
                        <Link className="industry-link"
                        //  to="manufacturingpage"
                        >WHITE PAPERS</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              )}
            </li>


            <li className="dropdown">
              <Link
                to="/"
                onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
                className='nav-link'
              >
                About Us
              </Link>
              <span
                onClick={(e) => {
                  e.preventDefault(); // Prevents navigation
                  setIsWhatWeDoDropdownOpens(!isWhatWeDoDropdownOpens);
                }}
                style={{ cursor: 'pointer', marginTop: '10px', color: '#fff' }} // Style for better UX
              >
                {/* Replace with an icon component or <i> element if needed */}
                ▼
              </span>
              {isWhatWeDoDropdownOpens && (
                <ul className="dropdown-menu">

                  <li onMouseEnter={() => handleMouseEnter('Service 18 - Industry 1')}>
                    <Link className="industry-link"
                      onClick={() => setIsSidebarOpen(false)}
                      to="aboutleadership"
                    >
                      Leadership
                    </Link>
                  </li>
                  <li onMouseEnter={() => handleMouseEnter('Service 19 - Industry 1')}>
                    <Link className="industry-link"
                      onClick={() => setIsSidebarOpen(false)}
                    // to="firstvalue"
                    >
                      ValueFirst
                    </Link>
                  </li>
                  <li onMouseEnter={() => handleMouseEnter('Service 4 - Industry 1')}>
                    <Link className="industry-link"
                      onClick={() => setIsSidebarOpen(false)}
                    //  to="aboutdiversity"
                    >
                      Diversity & Inclusion
                    </Link>
                  </li>
                </ul>
              )}
            </li>


            <li>
              <Link
                to="/talktous"
                onClick={() => setIsSidebarOpen(false)}
                className={`nav-link ${location.pathname === '/contact' ? 'active-link' : ''}`}
              >
                Talk to Us
              </Link>
            </li>

            {/* Dropdown menu for mobile view */}

          </ul>
        </div>
      </div>

      {/* Sidebar and Active Link CSS */}
      <style jsx>{`
        .sidebar {
          position: fixed;
          top: 0;
          right: -250px; /* Start off-screen */
          width: 250px;
          height: 100%;
          background-color: #313840;
          transition: right 0.3s ease-in-out; /* Smooth transition */
          z-index: 1000; /* Ensure it stays on top */
        }

        .sidebar.open {
          right: 0; /* Slide in */
          width:100%;
        }

        .sidebar-content ul {
          padding: 0;
          list-style: none;
          margin: 0;
        }

        .sidebar-content ul li {
          padding: 15px 20px;
          border-bottom: 1px solid #444;
        }

        .sidebar-content ul li a {
          color: white;
          text-decoration: none;
        }

        .toggle-button {
          cursor: pointer;
        }

        .dropdown-toggle {
          background: none;
          border: none;
          color: white;
          padding: 10px;
          cursor: pointer;
          width: 100%;
          text-align: left;
        }

      

        /* Show toggle button and sidebar on larger screens */
        @media (min-width: 1200px) {
          .sidebar {
            display: none; /* Hide sidebar */
          }

          .toggle-button {
            display: block; /* Show toggle button */
          }

          /* Dropdown for mobile */
          .dropdown-toggle {
            display: none; /* Hide dropdown button on larger screens */
          }
        }

        /* For smaller screens (mobile view) */
        @media (max-width: 1200px) {
          .sidebar-content ul li {
            padding: 10px 20px;
            display:flex;
          }

          .dropdown-menu {
            display: block;
            background-color: #313840;
            border-top: 1px solid #313840;
          }

          .dropdown-menu li a {
            padding-left: 40px; /* Indent dropdown items */
          }

          .sidebar-content ul li .dropdown-menu li {
            padding: 10px;
          }
        }
      `}</style>
      {/* Suggestion Dropdown */}
      {filteredSuggestions.length > 0 && (
        <div className="suggestion-dropdown">
          {filteredSuggestions.map((suggestion, index) => (
            <div key={index} className="suggestion-item" onClick={() => handleSuggestionClick(suggestion)}>
              {suggestion.label}
            </div>
          ))}
        </div>
      )}

      <style jsx>{`

       .dropdown-toggle-btn {
          transition: transform 0.3s ease-in-out; /* Smooth rotation transition */
        }

        .rotated {
          transform: rotate(180deg); /* Rotate when clicked */
        }
       .dropdown-toggle-btn {
          background: none;
          border: 1px solid #fff;
          cursor: pointer;
          font-size: 14px;
          margin-left: 5px;
          color: rgb(236 115 34);
        }
        .sub-dropdown {
          list-style: none;
          padding: 5px;
          background: #fff;
          border: 1px solid #ccc;
          position: absolute;
          width: 200px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          margin-top: 5px;
        }
        .sub-dropdown li {
          padding: 1px 10px;
        }
        .sub-dropdown li:hover {
          background: #575353;
        }

      /* Add a hover effect for the dropdown */
.nav-item:hover .dropdown-menu {
  display: block;
}

.nav-item .dropdown-menu {
  display: none;
  position: absolute;
  background-color: white;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  min-width: 160px;
  z-index: 1;
  margin-top: -31px;
  margin-left:-20px;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
}

 /* Nav Link */
.nav-link {
  font-weight: bold;
  font-size: 20px;
  margin: 0;
}

/* Mega Dropdown Container */
.mega-dropdown-container {
  position: relative;
}


/* Mega Dropdown */
.mega-dropdown {
  position: absolute;
  top: 108%;
  left:11%;
  background-color: #fff;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  width: 102vw;
  max-width: 1565px;
  padding: 40px;
  display: none; /* Hidden by default */
  z-index: 999;
  transform: translateX(-50%);
  justify-content: space-around;
  flex-wrap: wrap;
  height: 400px;
}
  @media (max-width: 1490px) {
  .mega-dropdown {
  left:22% !important;
   width: 118vw !important;
  }
   .dropdowm-one-data{
    margin-left: 50px !important;
   }
 
    .mega-dropdownss {
  left:1% !important;
   width: 125vw !important;
  }

}

  @media (min-width: 1545px) {
  .mega-dropdown {
  left:-31% !important;
   max-width:2140px !important;
   width: 116vw !important;
  }
  
   .industry-img-data {
   height:304px !important;
   width: 916px !important;
   margin-left: 72px !important;
   }
      }

@media (min-width: 1490px) {
 
  // .mega-dropdowns {
  // left:-102% !important;
  //  max-width:2540px !important;
  //  width: 135vw !important;
  // }

   .industry-img-datas {
    height:304px !important;
   width: 993px !important;
   margin-left: 72px !important;
   }
      }


      @media (min-width: 1550px) {
 
  .mega-dropdowns {
  left:-102% !important;
   max-width:2540px !important;
   width: 135vw !important;
  }

   .industry-img-datas {
    height:304px !important;
   width: 993px !important;
   margin-left: 72px !important;
   }
      }


@media (min-width: 1490px) {
   .mega-dropdownss {
  left:-49% !important;
   max-width:2340px !important;
   width: 126vw !important;
  }
    .industry-img-datass {
    height:304px !important;
   width: 1123px !important;
   margin-left: 72px !important;
   }
      }
@media (max-width: 1225px) {
      .industries-title::after {
       width: 260% !important;
      }
      
      }
 @media (max-width: 1510px) {
 
 .mega-dropdowns {
  
   width: 118vw !important;
  }
      }
  @media (max-width: 1260px) {
 
 .mega-dropdowns {
  left:-125% !important;
  
  }
      }
 
.dropdown-section ul {
  padding-left: 0;
}

.dropdown-section li h4 {
  margin: 0 0 10px 0;
}

.industry-image img {
  border-radius: 8px;
}

/* Dropdown Section */
.dropdown-section {
  flex: 1;
  padding: 20px;
  min-width: 200px;
}

.mega-dropdowns {
  position: absolute;
  top: 108%;
  left: -148%;
  background-color: #fff;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  width: 100vw;
  max-width: 1528px;
  padding: 40px;
  display: none; /* Hidden by default */
  z-index: 999;
  transform: translateX(-50%);
  justify-content: space-around;
  flex-wrap: wrap;
  height:400px;
}

.mega-dropdowns-container {
  position: relative;
}

/* Show dropdown on hover of the container */
.mega-dropdowns-container:hover .mega-dropdowns {
  display: flex;
}

/* Dropdown Links */
.mega-dropdowns h4 {
  font-size: 1.5rem;
  color: rgb(236 115 34);
}

.mega-dropdowns ul {
  list-style: none;
  padding: 0;
}

.mega-dropdowns ul li a {
  color: #333;
  text-decoration: none;
  display: block;
  padding: 5px 0;
}

.mega-dropdowns ul li a:hover {
  text-decoration: underline;
}

.mega-dropdownss {
  position: absolute;
  top: 108%;
  left: -340% !important;
  background-color: #fff;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  width: 100vw;
  max-width: 1519px;
  padding: 40px;
  display: none; /* Hidden by default */
  z-index: 999;
  transform: translateX(-50%);
  justify-content: space-around;
  flex-wrap: wrap;
  height: 400px;
}

/* Show dropdown when the 'open' class is added */
.mega-dropdownss.open {
  display: flex; /* Make it visible */
}

.mega-dropdownss-container:hover .mega-dropdowns {
  display: flex; /* Optional: still show on hover if you need it too */
}

/* Dropdown Links */
.mega-dropdownss h4 {
  font-size: 1.5rem;
  color: rgb(236 115 34);
}

.mega-dropdownss ul {
  list-style: none;
  padding: 0;
}

.mega-dropdownss ul li a {
  color: #333;
  text-decoration: none;
  display: block;
  padding: 5px 0;
}

.mega-dropdownss ul li a:hover {
  text-decoration: underline;
}


/* Show dropdown on hover of the container */
.mega-dropdown-container:hover .mega-dropdown {
  display: flex;
}

/* Dropdown Links */
.mega-dropdown h4 {
  font-size: 1.5rem;
  color: rgb(236 115 34);
}

.mega-dropdown ul {
  list-style: none;
  padding: 0;
}

.mega-dropdown ul li a {
  color: #333;
  text-decoration: none;
  display: block;
  padding: 5px 0;
}

.mega-dropdown ul li a:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 767px) {
  .mega-dropdown {
    position: static;
    transform: none;
    width: 100%;
    padding: 20px;
    box-shadow: none;
    display: none;
  }

  .mega-dropdown-container:hover .mega-dropdown {
    display: block;
  }
}

/* Left Column: Industry Names */
.industries-list {
  flex: 1;
  max-width: 50%;
  padding: 20px;
}

.industries-list ul {
  list-style: none;
  padding: 0;
}

.industries-list h4 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.industries-list li {
  margin-bottom: 0px;
}

/* Right Column: Images */
.industry-image {
  flex: 1;
  max-width: 50%;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.industry-image img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

/* Responsive Design */
@media (max-width: 767px) {
  .dropdown-content {
    flex-direction: column;
  }

  .industries-list,
  .industry-image {
    max-width: 100%;
  }
}



.dropdown-section ul {
  padding-left: 0;
}

.dropdown-section li h4 {
  margin: 0 0 10px 0;
}

.industry-image img {
  border-radius: 8px;
}
  /* Remove underline and change color on hover */
.industry-link {
  text-decoration: none; /* Remove underline */
  color: #000; /* Set default color */
  transition: color 0.3s ease; /* Smooth transition for color change */
}

.industry-link:hover {
  color:rgb(236 115 34); /* Custom hover color (change as needed) */
  text-decoration: none; /* Ensure underline is not added */
}
.industries-title {
  position: relative;
  display: inline-block;
  padding-bottom: 5px; /* Adds spacing below the text */
}

.industries-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 266%;
  height: 1px; /* Thickness of the line */
  background-color: #ccc; /* Color of the line */
}
.industries-titless {
  position: relative;
  display: inline-block;
  padding-bottom: 5px; /* Adds spacing below the text */
}

.industries-titless::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 209%;
  height: 1px; /* Thickness of the line */
  background-color: #ccc; /* Color of the line */
}

.industries-titles {
  position: relative;
  display: inline-block;
  padding-bottom: 5px; /* Adds spacing below the text */
}

.industries-titles::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 270%;
  height: 1px; /* Thickness of the line */
  background-color: #ccc; /* Color of the line */
}


`}</style>


    </>
  );
};

export default Nav;
